/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UnauthorizedHeader.vue?vue&type=template&id=a7e9a144"
import script from "./UnauthorizedHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnauthorizedHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UnauthorizedHeader.vue?vue&type=style&index=0&id=a7e9a144&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports